export default __webpack_public_path__ + "static/media/error.7e9dd5d0.png";